import React from 'react';
import { Col, Row, Form, Input } from 'antd';
import RichTextEditorComponent from '../../../../../../common/components/texteditor/RichTextEditorComponent';
const { TextArea } = Input;

function DescriptionFeaturesTab({ form }) {
  const onDescriptionChange = (value) => {
    form?.setFieldValue('product_description', value);
  };
  const onInboxChange = (value) => {
    form?.setFieldValue('product_inbox', value);
  };
  return (
    <Row gutter={24} justify={'start'} style={{ height: '100%' }}>
      <Col span={12} style={{ height: '100%' }}>
        <Form.Item
          style={{ height: '100%' }}
          name="product_description"
          label="Description"
          rules={[
            {
              required: true,
              message: 'Please input product description',
            },
          ]}
        >
          {/* <TextArea rows={16} placeholder="Product Description" /> */}
          <RichTextEditorComponent  />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item name="product_inbox" label="Contents">
          <RichTextEditorComponent />
        </Form.Item>
      </Col>
      {/* <Col span={24}>
      
    </Col> */}
    </Row>
  );
}

export default DescriptionFeaturesTab;
